import angular from "angular";
import _ from "lodash";
import { Icon } from "dlweb-components";

const navigateToFile = {
  key: 'navigateToFile',
  action: 'navigateToFile',
  icon: <Icon type="folder" className="menu-icon" />,
  label: 'Go To File Location'
}

angular.module("webTools").factory("MenuBuilder", [
  "$rootScope",
  "Auth",
  "GridTools",
  "$ngRedux",
  function ($rootScope, Auth, GridTools, $ngRedux) {
    return {
      getFileContextMenu: function (selectedItems, gridData, view) {
        const store = $ngRedux.getState();

        view = view || "documents";

        var menuCollection = [];

        // initialize menu sections
        menuCollection[0] = [];
        menuCollection[1] = [];
        menuCollection[2] = [];
        menuCollection[3] = [];
        menuCollection[4] = [];

        menuCollection[0].push({
          key: "download",
          action: "launchLegacyDialog",
          icon: <Icon type="file-download" className="menu-icon" />,
          label: "Download",
        });

        if (!Auth.isWebView()) {
          menuCollection[1].push({
            key: "message",
            action: "launchLegacyDialog",
            icon: <Icon type="envelope" className="menu-icon" />,
            label: "Send Notification",
          });
        }

        if (store.app.bravaVersion === "16.3") {
          menuCollection[0].unshift({
            key: "bravahtml",
            action: "launchLegacyDialog",
            icon: <Icon type="eye" className="menu-icon" />,
            label: "View In Brava!",
          });
        }

        if (selectedItems.length === 1) {
          menuCollection[0].unshift({
            key: "preview",
            action: "launchLegacyDialog",
            icon: <Icon type="eye" className="menu-icon" />,
            label: "Preview",
          });

          if (Auth.isWebView()) {
            if(view.toLowerCase() === 'search' && selectedItems.length === 1) {
              menuCollection[0].push({ type: "divider" })
              menuCollection[0].push(navigateToFile)
            }
            return menuCollection[0];
          }

          menuCollection[2].push(
            {
              key: "versionhistory",
              action: "launchLegacyDialog",
              icon: <Icon type="history" className="menu-icon" />,
              label: "History",
            },
            {
              key: "documentlog",
              action: "openDocumentLogDialog",
              icon: <Icon type="file-alt" className="menu-icon" />,
              label: "Document Log",
            },
            {
              key: "notes",
              action: "launchLegacyDialog",
              icon: <Icon type="sticky-note" className="menu-icon" />,
              label: "Document Notes",
            },
            {
              key: "updateprofile",
              action: "openUpdateProfileDialog",
              icon: <Icon type="pen-square" className="menu-icon" />,
              label: "Update Profile",
            }
          );

          if (selectedItems.length === 1 && selectedItems[0].StatusFlags & 64) {
            menuCollection[2].unshift({
              key: "relatedmessages",
              action: "launchLegacyDialog",
              icon: <Icon type="mail-bulk" className="menu-icon" />,
              label: "Related Messages",
            });
          }

          if (
            _.includes(_.map(selectedItems, "Activity"), "In Process") &&
            selectedItems.length === 1
          ) {
            menuCollection[1].push({
              key: "task",
              action: "launchLegacyDialog",
              icon: <Icon type="scroll" className="menu-icon" />,
              label: "Workflow Task",
            });
          }

          menuCollection[3].push(
            {
              key: "rename",
              action: "openRenameDialog",
              icon: <Icon type="pen" className="menu-icon" />,
              label: "Rename File",
            },
            {
              key: "getFileLink",
              action: "openLinkDialog",
              icon: <Icon type="link" className="menu-icon" />,
              label: "Link",
            }
          );

          if(view.toLowerCase() === 'search' && selectedItems.length === 1) {
            menuCollection[3].push(navigateToFile)
          }
        }

        if (!Auth.isWebView()) {
          if (_.includes(_.map(selectedItems, "Status"), "Normal")) {
            menuCollection[0].push({
              key: "checkout",
              action: "launchLegacyDialog",
              icon: <Icon type="check" className="menu-icon" />,
              label: "Check Out",
            });

            if (
              view.toLowerCase() === "projects" &&
              selectedItems.length === 1
            ) {
              menuCollection[0].push({
                key: "checkout-sync",
                action: "launchLegacyDialog",
                icon: <Icon type="check" className="menu-icon" />,
                label: "Check Out Sync",
              });
            }
          }

          if (
            _.includes(_.map(selectedItems, "Status"), "Checked Out") &&
            _.includes(_.map(selectedItems, "CheckedOutBy"), Auth.getUsername())
          ) {
            if (view.toLowerCase() === "projects") {
              menuCollection[0].push({
                key: "project-checkin",
                action: "openCheckinDialog",
                icon: <Icon type="file-upload" className="menu-icon" />,
                label: "Check In",
              });
              menuCollection[0].push({
                key: "project-undocheckout",
                action: "launchLegacyDialog",
                icon: <Icon type="undo" className="menu-icon" />,
                label: "Undo Check Out",
              });
            } else {
              menuCollection[0].push(
                {
                  key: "checkin",
                  action: "openCheckinDialog",
                  icon: <Icon type="file-upload" className="menu-icon" />,
                  label: "Check In",
                },
                {
                  key: "undocheckout",
                  action: "launchLegacyDialog",
                  icon: <Icon type="undo" className="menu-icon" />,
                  label: "Undo Check Out",
                }
              );
            }
          }

          menuCollection[1].push(
            {
              key: "workflow",
              action: "launchLegacyDialog",
              icon: <Icon type="cogs" className="menu-icon" />,
              label: "Start Workflow",
            },
            {
              key: "quickapprovalworkflow",
              action: "launchLegacyDialog",
              icon: <Icon type="cogs" className="menu-icon" />,
              label: "Quick Approval Workflow",
            }
          );

          if (view.toLowerCase() === "documents") {
            menuCollection[4].push({
              key: "delete",
              action: "launchLegacyDialog",
              icon: <Icon type="trash" className="menu-icon" />,
              label: "Delete",
            });
          } else if (view.toLowerCase() === "projects") {
            menuCollection[4].push({
                key: "project-removefile",
                action: "openConfirmation",
                icon: <Icon type="trash" className="menu-icon" />,
                label: "Remove From Projects",
              });
          }
        }

        const mc = [
          menuCollection[0],
          menuCollection[1],
          menuCollection[2],
          menuCollection[3],
          menuCollection[4],
        ];

        return mc
        .filter(arr => arr.length > 0) // remove empty arrays
        .flatMap((menu, index, filteredCollection) =>
          index < filteredCollection.length - 1
            ? [...menu, { type: "divider" }]
            : menu
        );
      
      },
      getVersionedSearchMenu: function (selectedItems) {
        const store = $ngRedux.getState();

        var menuCollection = [];
        menuCollection[0] = [];
        menuCollection[1] = [];

        menuCollection[0].push({
          key: "download",
          action: "launchLegacyDialog",
          icon: <Icon type="file-download" />,
          label: "Download",
        });

        if (store.app.bravaVersion === "16.3") {
          menuCollection[0].unshift({
            key: "bravahtml",
            action: "launchLegacyDialog",
            icon: <Icon type="eye" />,
            label: "View In Brava!",
          });
        }

        menuCollection[0].unshift({
          key: "preview",
          action: "launchLegacyDialog",
          icon: <Icon type="eye" />,
          label: "Preview",
        });

        if (Auth.isWebView()) {
          if(selectedItems.length === 1) {
            menuCollection[0].push({ type: "divider" })
            menuCollection[0].push(navigateToFile)
          }
          return menuCollection[0];
        }

        if (!Auth.isWebView()) {
          if (_.includes(_.map(selectedItems, "Status"), "Normal")) {
            menuCollection[0].push({
              key: "checkout",
              action: "launchLegacyDialog",
              icon: <Icon type="check" />,
              label: "Check Out",
            });
          }

          if (
            _.includes(_.map(selectedItems, "Status"), "Checked Out") &&
            _.includes(_.map(selectedItems, "CheckedOutBy"), Auth.getUsername())
          ) {
            menuCollection[0].push({
              key: "checkin",
              action: "launchLegacyDialog",
              icon: <Icon type="file-upload" />,
              label: "Check In",
            });

            menuCollection[0].push({
              key: "undocheckout",
              action: "launchLegacyDialog",
              icon: <Icon type="undo" />,
              label: "Undo Check Out",
            });
          }
        }

        menuCollection[1].push({
          key: "updateprofile",
          action: "openUpdateProfileDialog",
          icon: <Icon type="pen-square" />,
          label: "Update Profile",
        });

        if(selectedItems.length === 1) {
          menuCollection[1].push({ type: "divider" })
          menuCollection[1].push({
              key: 'navigateToFile',
              action: 'navigateToFile',
              icon: <Icon type="folder" className="menu-icon" />,
              label: 'Go To File Location'
            }
          )
        }

        return [
          ...menuCollection[0],
          { type: "divider" },
          ...menuCollection[1],
        ];
      },
      getProjectFileContextMenu: function (selectedItems) {
        const store = $ngRedux.getState();

        let menuCollection = [];
        menuCollection[0] = [];
        menuCollection[1] = [];
        menuCollection[2] = [];

        menuCollection[0].push({
          key: "download",
          action: "launchProjectFileDialog",
          icon: <Icon type="file-download" />,
          label: "Download",
        });

        if (store.app.bravaVersion === "16.3") {
          menuCollection[0].unshift({
            key: "bravahtml",
            action: "launchProjectFileDialog",
            icon: <Icon type="eye" />,
            label: "View In Brava!",
          });
        }

        if (selectedItems.length === 1) {
          menuCollection[0].unshift({
            key: "preview",
            action: "launchProjectFileDialog",
            icon: <Icon type="eye" />,
            label: "Preview",
          });

          if (Auth.isWebView()) {
            return menuCollection;
          }

          menuCollection[1].push(
            {
              key: "versionhistory",
              action: "launchProjectFileDialog",
              icon: <Icon type="history" />,
              label: "History",
            },
            {
              key: "updateprofile",
              action: "openUpdateProfileDialog",
              icon: <Icon type="pen-square" />,
              label: "Update Profile",
            }
          );

          if (selectedItems.length === 1 && selectedItems[0].StatusFlags & 64) {
            menuCollection[0].unshift({
              key: "relatedmessages",
              action: "launchProjectFileDialog",
              icon: <Icon type="mail-bulk" />,
              label: "Related Messages",
            });
          }
        }

        if (!Auth.isWebView()) {
          if (_.includes(_.map(selectedItems, "Status"), "Normal")) {
            menuCollection[0].push({
              key: "project-checkout",
              action: "launchProjectFileDialog",
              icon: <Icon type="check" />,
              label: "Check Out",
            });
          }

          if (
            _.includes(_.map(selectedItems, "Status"), "Checked Out") &&
            _.includes(_.map(selectedItems, "CheckedOutBy"), Auth.getUsername())
          ) {
            menuCollection[0].push({
              key: "project-checkin",
              action: "launchProjectFileDialog",
              icon: <Icon type="file-upload" />,
              label: "Check In",
            });

            menuCollection[0].push({
              key: "project-undocheckout",
              action: "launchProjectFileDialog",
              icon: <Icon type="undo" />,
              label: "Undo Check Out",
            });
          }

          menuCollection[2].push({
            key: "project-removefile",
            action: "launchProjectFileDialog",
            icon: <Icon type="trash" />,
            label: "Remove From Project",
          });
        }

        return [
          ...menuCollection[0],
          { type: "divider" },
          ...menuCollection[1],
          { type: "divider" },
          ...menuCollection[2],
        ];
      },
      getProjectContextMenu: function (selectedItems) {
        let menuCollection = [];

        menuCollection[0] = [
          {
            key: "project-getlatest",
            action: "launchProjectDialog",
            payload: selectedItems[0].ID,
            icon: <Icon type="download" />,
            label: "Download",
          },
        ];

        menuCollection[1] = [
          {
            key: "project-checkout",
            action: "launchProjectDialog",
            payload: selectedItems[0].ID,
            icon: <Icon type="check" />,
            label: "Check Out",
          },
        ];

        menuCollection[1].push({
          key: "project-checkin",
          action: "launchProjectDialog",
          payload: selectedItems[0].ID,
          icon: <Icon type="file-upload" />,
          label: "Check In",
        });

        menuCollection[1].push({
          key: "project-undocheckout",
          action: "launchProjectDialog",
          payload: selectedItems[0].ID,
          icon: <Icon type="undo" />,
          label: "Undo Check Out",
        });

        menuCollection[2] = [
          {
            key: "project-addfile",
            action: "launchProjectDialog",
            payload: selectedItems[0].ID,
            icon: <Icon type="file-plus" />,
            label: "Add File",
          },
        ];

        menuCollection[2].push({
          key: "project-edit",
          action: "launchProjectEditor",
          payload: selectedItems[0].ID,
          icon: <Icon type="edit" />,
          label: "Edit Project",
        });

        menuCollection[2].push({
          key: "project-newversion",
          action: "openConfirmation",
          icon: <Icon type="layer-plus" />,
          label: "New Version",
        });

        menuCollection[2].push({
          key: "project-rename",
          action: "launchProjectDialog",
          payload: selectedItems[0].ID,
          icon: <Icon type="pen" />,
          label: "Rename Project",
        });

        menuCollection[3] = [
          {
            key: "project-delete",
            action: "openConfirmation",
            icon: <Icon type="trash" />,
            label: "Delete",
          },
        ];

        return [
          ...menuCollection[0],
          { type: "divider" },
          ...menuCollection[1],
          { type: "divider" },
          ...menuCollection[2],
          { type: "divider" },
          ...menuCollection[3],
        ];
      },

      getRecycleContextMenu: function () {
        var menuCollection = [];

        menuCollection.push(
          {
            key: "restore",
            action: "launchLegacyDialog",
            icon: <Icon type="trash-restore" />,
            label: "Restore",
          },
          {
            key: "permanentdelete",
            action: "launchLegacyDialog",
            icon: <Icon type="trash-alt" />,
            label: "Permanently Delete",
          }
        );

        return menuCollection;
      },

      getMessageContextMenu: function (selectedItems) {
        if (selectedItems.length === 0) {
          return [];
        }

        selectedItems = _.compact(selectedItems);

        let menuCollection = [];

        menuCollection[0] = [];
        menuCollection[1] = [];
        menuCollection[2] = [];

        if (_.includes(_.map(selectedItems, "MessageRead"), "0")) {
          menuCollection[1].push({
            key: "markRead",
            action: "markRead",
            icon: <Icon type="envelope-open" />,
            label: "Mark As Read",
          });
        }

        if (_.includes(_.map(selectedItems, "MessageRead"), "1")) {
          menuCollection[1].push({
            key: "markUnread",
            action: "markUnread",
            icon: <Icon type="envelope" />,
            label: "Mark As Unread",
          });
        }

        menuCollection[2].push({
          key: "launchMessageDelete",
          action: "launchMessageDelete",
          icon: <Icon type="trash" />,
          label: "Delete",
        });

        if (selectedItems.length === 1 && !Auth.isWebView()) {
          menuCollection[0].push({
            key: "launchMessageReply",
            action: "launchMessageReply",
            icon: <Icon type="reply" />,
            label: "Reply",
          });
          menuCollection[0].push({
            key: "launchMessageForward",
            action: "launchMessageForward",
            icon: <Icon type="share" />,
            label: "Forward",
          });
        } else {
          menuCollection = _.remove(menuCollection, 0);
        }

        return [
          ...menuCollection[0],
          { type: "divider" },
          ...menuCollection[1],
          { type: "divider" },
          ...menuCollection[2],
        ];
      },

      getFolderMenu: function () {
        var menuCollection = [];
        const { permissions } = $ngRedux.getState().workingFolder;

        if (!Auth.isWebView()) {
          menuCollection.push(
            {
              key: "newfile",
              action: "launchFolderDialog",
              icon: <Icon type="file-plus" />,
              label: "New Document",
              disabled: permissions.addData == 0,
            },
            {
              key: "import",
              action: "launchFolderDialog",
              icon: <Icon type="file-import" />,
              label: "Import",
              disabled: permissions.addData == 0 || permissions.allowImport == 0,
            },
            {
              key: "newfolder",
              action: "launchFolderDialog",
              icon: <Icon type="folder-plus" />,
              label: "New Folder",
              disabled: permissions.addFolder == 0,
            },
            {
              key: "newstructure",
              action: "launchFolderDialog",
              icon: <Icon type="folders" />,
              label: "New Folder Structure",
              disabled: permissions.addFolder == 0,
            }
          );

          if ($rootScope.workingFolder !== "Documents") {
            menuCollection.push(
              {
                key: "renameFolder",
                action: "launchFolderDialog",
                icon: <Icon type="pen" />,
                label: "Rename Folder",
              },
              {
                key: "getFolderLink",
                action: "launchFolderDialog",
                icon: <Icon type="link" />,
                label: "Generate Link",
              }
            );
          }
        }
        return menuCollection;
      },

      getProjectFolderMenu: function () {
        var menuCollection = [];

        menuCollection.push(
          {
            key: "project-new",
            action: "launchFolderDialog",
            icon: <Icon type="plus" />,
            label: "New Project",
          },
          {
            key: "project-newfolder",
            action: "launchFolderDialog",
            icon: <Icon type="folder-plus" />,
            label: "New Folder",
          }
        );

        if ($rootScope.workingFolder !== "Projects") {
          menuCollection.push({
            key: "rename-folder",
            action: "launchFolderDialog",
            icon: <Icon type="pen" />,
            label: "Rename Folder",
          });
        }

        return menuCollection;
      },

      getRecycleMenu: function () {
        var menuCollection = [];

        menuCollection.push(
          {
            key: "restoreBin",
            action: "launchFolderDialog",
            icon: <Icon type="trash-restore" />,
            label: "Restore Recycle Bin",
          },
          {
            key: "emptyBin",
            action: "launchFolderDialog",
            icon: <Icon type="trash-alt" />,
            label: "Empty Recycle Bin",
          }
        );

        return menuCollection;
      },
    };
  },
]);
